import { useEffect, useState } from 'react'
import { LockActivity, UnlockActivity } from '../services/AnnualPlanService'

type BaseModalState = 'add' | 'delete' | 'track' | 'update' | 'clearTrack' | 'none'

export type ModalState<T extends string = never> = BaseModalState | T

interface UseModalStateType<T, S extends string> {
  currentItem?: T
  modalState: ModalState<S>
  setModalState: (state: ModalState<S>) => void
  startModal: (state: ModalState<S>, item?: T) => Promise<void>
  handleCloseModal: () => Promise<void>
}

export const useModalState = <T extends { id: number, isUpdate: boolean }, S extends string = never>(lockName: string): UseModalStateType<T, S> => {
  const [currentItem, setCurrentItem] = useState<T | undefined>(undefined)
  const [modalState, setModalState] = useState<ModalState<S>>('none')

  useEffect(() => {
    if (modalState === 'none') {
      if (currentItem == null) return
      setCurrentItem(undefined)
    }
  }, [modalState])

  const handleCloseModal = async (): Promise<void> => {
    if (currentItem != null) {
      await UnlockActivity(currentItem.id, lockName, currentItem.isUpdate)
    }
    setModalState('none')
  }

  const startModal = async (state: ModalState<S>, item?: T): Promise<void> => {
    if (item != null) {
      await LockActivity(item.id, lockName, item.isUpdate)
      setCurrentItem(item)
    }
    setModalState(state)
  }

  return { modalState, startModal, currentItem, handleCloseModal, setModalState }
}
